import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { customAccountSettingsReducer } from "@solveindustrial/Store/State/AccountSettings/AccountSettingsReducer";
import { CustomAccountSettingsState } from "@solveindustrial/Store/State/AccountSettings/AccountSettingsState";
import { customBlogListReducer, CustomBlogListState } from "@solveindustrial/Store/State/Blog/BlogListState";
import { contentSearchReducer } from "@solveindustrial/Store/State/ContentSearch/ContentSearchReducer";
import { ContentSearchState } from "@solveindustrial/Store/State/ContentSearch/ContentSearchState";
import { customShippingAcountNumberReducer } from "@solveindustrial/Store/State/Custom/ShippingAccount/ShippingAccountNumberReducer";
import { CustomShippingAccountNumberState } from "@solveindustrial/Store/State/Custom/ShippingAccount/ShippingAccountNumberState";

export type CustomState = {
    name: string;
    blogList: CustomBlogListState;
    accountSettings: CustomAccountSettingsState;
    shippingAccountNumberState: CustomShippingAccountNumberState;
    contentSearch: ContentSearchState;
} & ApplicationState;

(reducers as any).blogList = customBlogListReducer;
(reducers as any).accountSettings = customAccountSettingsReducer;
(reducers as any).shippingAccountNumberState = customShippingAcountNumberReducer;
(reducers as any).contentSearch = contentSearchReducer;

type Reducers = {
    customBlogListReducer: typeof customBlogListReducer;
    customAccountSettingsReducer: typeof customAccountSettingsReducer;
    customShippingAcountNumberReducer: typeof customShippingAcountNumberReducer;
    contentSearchReducer: typeof contentSearchReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
